"use client";
import React, { useEffect, useMemo } from "react";
import { Container, Accordion } from "react-bootstrap";
import SectionTitle from "@/components/common-components/SectionTitle";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchFAQs } from "@/redux/faqSlice";

const FaqSection = ({

    sectionName = "FAQ",
    title = "Frequently Asked Questions",
    className = "",
}) => {
  
    const dispatch = useDispatch();
    const faqs = useSelector((state) => state.faq.faqs);
    const status = useSelector((state) => state.faq.status);


    const payload = useMemo(() => ({
        organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
    }), []);


    useEffect(() => {
        if (status === 'idle') {

            dispatch(fetchFAQs({ payload }));
        }
    }, [dispatch, payload]);
    return (
        <section className={`faq-section ${className}`}>
            <Container>
                <SectionTitle
                    sectionName={sectionName}
                    title={title}
                    className="mx-auto text-center title"
                    style={{ maxWidth: "534px", marginBottom: "56px" }}
                />
                <div className="mx-auto" style={{maxWidth:"700px"}}>
                    <Accordion defaultActiveKey="0" className="custom-accordion">
                        {faqs?.data?.map((faq, i) => (
                            <Accordion.Item eventKey={i} key={i}>
                                <Accordion.Header>
                                    <span className="faq-question pe-5">{faq.question}</span>
                                    <span className="plus-vert"></span>
                                </Accordion.Header>
                                <Accordion.Body dangerouslySetInnerHTML={{ __html: faq.answer }} />
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>
            </Container>
        </section>
    );
};

export default FaqSection;